/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useContext } from 'react';
import { PageTitle } from '@project/components';
import MenuToggle from '../Shared/MenuToggle/MenuToggle';
import AdminLogout from '../AdminLogout/AdminLogout';
import CompanySelect from '../CompanySelect/CompanySelect';
import CompanySettingsTabs from '../CompanySettingsTabs/CompanySettingsTabs';
import axios from '../../utils/axios';
import { Alert } from 'react-bootstrap';
import { useIntl } from 'react-intl';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { RootContext } from '../../hoc/RootContext/RootContext';

function CompanySettings(props) {
  const intl = useIntl();
  const t = (id) => intl.formatMessage({ id });
  const { currentUser } = useContext(RootContext);
  const id360Admin = currentUser.is_id360_admin;

  const navigate = useNavigate();

  const query = new URLSearchParams(useLocation().search);

  const queryCompany = query.get("company");

  const [selectedCompany, setSelectedCompany] = useState(null); // TODO: Set this back to null
  const [isSaving, setIsSaving] = useState(false);
  const [errors, setErrors] = useState(null);
  const [companyRecord, setCompanyRecord] = useState(null);
  const [companySettings, setCompanySettings] = useState(null);

  // sends the space profile to the api to save
  const onSaveCompanySettings = async (companySettings) => {
    if (isSaving) return;
    setIsSaving(true);
    try {
      await toast.promise(axios.put(`/company-settings/${encodeURIComponent(selectedCompany.value)}`, companySettings), {
        pending: t('ui.saving') + '...',
        success: t('CompanySettings.saveSuccessful'),
        error: t('error.general')
      });
    } catch (e) {
      setErrors(`${t('error.general')}: ${e.errors}`);
    } finally {
      setIsSaving(false);
    }
  }

  // retrieves company record when company is selected
  useEffect(() => {
    // retrieve company to get up-to-date field visibility settings
    async function fetchCompany() {
      const result = await axios.get(`/companies/${encodeURIComponent(selectedCompany.value)}`);
      if (result.status === 200) {
        const data = result.data.record;
        setCompanyRecord(data);
        navigate(`/admin/company_settings${selectedCompany && selectedCompany.slug ? `?company=${selectedCompany.slug}` : ''}`, { replace: true });
      } else {
        setErrors(`${t('error.general')}: ${result.errors}`);
      }
    };

    // returns all other company settings, and inits the settings if necessary
    async function fetchCompanySettings() {
      try {
        const result = await axios.get(`/company-settings?name=${encodeURIComponent(selectedCompany.value)}`);
        if (result.status === 200) {
          const settings = result.data.record;
          setCompanySettings({ ...settings });
        } else {
          setErrors(`${t('error.general')}: ${result.errors}`);
        }
      } catch (err) {
      }
    };

    if (selectedCompany) {
      fetchCompany();
      fetchCompanySettings();
    }
  }, [selectedCompany]);

  if (!id360Admin) {
    return (
      <section className="">
        <PageTitle title={t('CompanySettings.pageTitle')} />
        <header>
          <div className='d-flex'>
            <MenuToggle />
            <h3 className='is-page-title ml-3'>{t('CompanySettings.title')}</h3>
          </div>
          <AdminLogout />
        </header>
        <main>
          <Alert variant='danger'>
            You are not authorized to view this page.
          </Alert>
        </main>
      </section>
    );
  }

  return (
    <section className="">
      <PageTitle title={t('CompanySettings.pageTitle')} />
      <header>
        <div className='d-flex'>
          <MenuToggle />
          <h3 className='is-page-title ml-3'>{t('CompanySettings.title')}</h3>
        </div>
        <AdminLogout />
      </header>
      <main>
        <div className="mb-5">
          {errors ? <Alert key={errors} variant='danger'>
            {Array.isArray(errors) ? errors.map((error, i) => <div key={`error${i}`}>{error.message}</div>) : <>{t('error')}: {errors}</>}
          </Alert> : null}
          <div className="col-md-6 pl-0"><CompanySelect defaultCompany={queryCompany} selectedCompany={selectedCompany} setSelectedCompany={setSelectedCompany} /></div>
        </div>

        {companyRecord && companySettings &&
          <CompanySettingsTabs
            companySettings={companySettings}
            selectedCompany={companyRecord}
            setcompanySettings={setCompanySettings}
            onSaveCompanySettings={onSaveCompanySettings}
            isSaving={isSaving} />
        }
      </main>
    </section>
  )
}

export default CompanySettings